<template>
  <div>
    <template v-if="ipAddressList.length === 0">any</template>
    <template v-else>
      <div v-for="(dstAddress, i) in sortedIpAddressList" :key="i">
        {{ dstAddress.ipAddressName || dstAddress.ipAddress }}
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { IntraPolicy } from "@/apis/IntranetfwPolicyApi";

/** ポリシー設定(イントラネットFW)の宛先アドレスを表示するコンポーネント */
export default defineComponent({
  name: "IntranetPolicyDstAddress",
  props: {
    /** 宛先アドレスリスト */
    ipAddressList: {
      type: Array as PropType<IntraPolicy["dstAddressList"]>,
      required: true,
    },
  },
  computed: {
    /**
     * ソート済みの宛先アドレスを返却する
     * アドレス名・アドレスの昇順
     */
    sortedIpAddressList() {
      return this.ipAddressList.sortBy([
        (e) => e.ipAddressName ?? e.ipAddress,
        "asc",
      ]);
    },
  },
});
</script>
